import React from 'react';
import { useSelector } from 'react-redux';
import MaskedInput from 'react-text-mask';

export default function ArrestTransactionTextMask(props) {
  const { inputRef, ...other } = props;

  const ibrsVersion = useSelector((state) => state.user?.ibrsVersion);

  const invalidCharsRegex = ibrsVersion === 'LA' ? /[^A-Z0-9\- ]/g : /[^A-Z0-9\-]/g;
  const maxCharacterAllowed = ibrsVersion === 'LA' ? 15 : 12;
  const allowedCharRegex = ibrsVersion === 'LA' ? /[A-Z0-9\- ]/ : /[A-Z0-9\-]/;

  // Dynamic mask function to allow A-Z, 0-9, hyphen, blank space (LIBRS) with max length of 12 or 15 (LIBRS)
  const createMask = (rawValue = '') => {
    const cleanValue = rawValue.toUpperCase().replace(invalidCharsRegex, ''); // Remove invalid characters

    // Generate mask dynamically based on maxlength
    return Array.from({ length: Math.min(cleanValue.length, maxCharacterAllowed) }).map(
      () => allowedCharRegex
    );
  };

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={createMask}
      placeholderChar={' '}
      showMask
      guide={false}
    />
  );
}
